/**
 * Bepaalt wie er in Aan, CC en BCC terechtkomt wanneer alle contacten samen één
 * mail krijgen (`enableRecipientTypes`, zie reno-tickets).
 *
 * De contactenlijst in de composer en de verzendfunctie moeten hier exact hetzelfde
 * over denken: staat er "Aan" naast een contact, dan moet die ook echt in het
 * TO-veld belanden. Daarom leeft de regel op één plek.
 */
import { RecipientType } from '../types';

/** Minimum dat nodig is om de rollen te bepalen — geen volledig `Contact`. */
export interface RecipientLike {
  email?: string;
  recipientType?: RecipientType;
}

/** Een contact zonder bruikbaar adres wordt bij het verzenden weggelaten. */
export function hasUsableEmail(contact: RecipientLike): boolean {
  const email = contact.email?.trim();
  return !!email && email !== 'GSM-nummer onbekend';
}

/**
 * Geeft per contact (zelfde volgorde als de invoer) de rol terug en vult de
 * ontbrekende keuzes aan:
 *
 * - een expliciete keuze op het contact wint altijd;
 * - is er nergens een expliciete "Aan", dan wordt het eerste contact mét adres de
 *   TO-ontvanger — het gedrag van vóór deze keuzelijst;
 * - alle overige contacten zonder keuze komen in CC.
 *
 * Heeft de gebruiker de TO-ontvanger zélf op CC of BCC gezet, dan blijft de mail
 * bewust zonder TO: iedereen in BCC moet kunnen.
 */
export function resolveRecipientTypes(contacts: RecipientLike[]): RecipientType[] {
  const heeftExplicieteTo = contacts.some((contact) => contact.recipientType === 'to');
  const implicieteToIndex = heeftExplicieteTo ? -1 : contacts.findIndex(hasUsableEmail);

  return contacts.map(
    (contact, index) => contact.recipientType ?? (index === implicieteToIndex ? 'to' : 'cc'),
  );
}
